import { Box, Card, CardContent, Grid } from '@mui/material';
import { Journey } from '../utils/types';

type ItineraryCardProps = {
    itinerary: Journey;
    index: number;
};

function ItineraryCard(props: ItineraryCardProps) {
    const { itinerary, index } = props;

    return (
        <Card
            sx={{
                margin: '10px',
                minWidth: '300px',
                maxHeight: '125px',
            }}
            variant='outlined'
            key={index}>
            <CardContent
                sx={{
                    padding: '16px !important',
                }}>
                <Grid
                    container
                    sx={{
                        flexWrap: 'nowrap',
                        justifyContent: 'space-between',
                    }}>
                    <Grid item sx={{}}>
                        <Box display={'flex'} flexDirection={'column'}>
                            <Box display={'flex'} flexDirection={'row'}>
                                <Box>
                                    <b>
                                        {itinerary.departureTime.replace(
                                            ':',
                                            'h'
                                        )}
                                    </b>
                                </Box>
                                <Box marginLeft={1}>{itinerary.origine}</Box>
                            </Box>
                            <Box display={'flex'} flexDirection={'row'}>
                                <Box>
                                    <b>
                                        {itinerary.arrivalTime.replace(
                                            ':',
                                            'h'
                                        )}
                                    </b>
                                </Box>
                                <Box marginLeft={1}>
                                    {itinerary.destination}
                                </Box>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid
                        item
                        xs={2}
                        display={'flex'}
                        flexDirection={'column'}
                        alignItems={'center'}
                        justifyContent={'center'}
                        marginRight={1}
                        marginLeft={1}>
                        <Box>
                            <Box>{itinerary.travelTime}</Box>
                        </Box>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
}

export default ItineraryCard;
